<template>
  <img src='../assets/GDQ-Associates-White.svg' width="400" height="60" alt="GDQ Associates Logo" />
</template>

<script>
export default {
  name: 'Logo'
}
</script>
